import { DecisionStatus, DecisionType, DisagreementReason } from './enums';
import { ErrorEntry } from './errors';

export interface DecisionBody {
  decision: DecisionType;
  disagreementReason: DisagreementReason | null;
  notes: string | null;
}

export interface DecisionRecord {
  decisionId: number;
  contentModerationEventId: number;
  decision: DecisionType;
  status: DecisionStatus;
  disagreementReason: DisagreementReason | null;
  notes: string | null;
  decidedAt: string;
  reviewerAccountId: number;
  isAutomated: boolean;
}

export interface DecisionSubmitResult {
  decision: DecisionRecord;
  warnings: ErrorEntry[];
}

export const NOTES_MAX_LENGTH = 1000;
export const RESET_REASON_MAX_LENGTH = 500;
